export const OfferType = {
	PPV:          'ppv',
	SUBSCRIPTION: 'subscription',
	PACKAGE:      'package',
};
